export const BING_MAP_API_KEY = "Ats6T7iZTbUAmnuODTDY1B_INRZ11rIBNjJn3S0pHa39PtOAks0bnzqoQ_Dx8aim";//"AuY6VncXsbTHeSGKgm88yi_pAYztma_YZrY_g54uue6VJi0S9WLsGb716mSJHC4x";
export const BING_MAP_LOCAL_API_URL_US = "https://dev.virtualearth.net/REST/v1/Locations/US";
export const OUTPUT = "?o=json";
export const SLASH = "/";
export const AND = "&";
export const KEY = "key=";
export const API_URI = ""; //"https://c460-182-70-23-60.ngrok.io/";